<template>
  <span>
    <b-card no-body>
      <b-card-header>
         <b-row>
          <b-col sm="12" md="9">
            <h3>{{$route.name}}</h3>
          </b-col>
          <b-col sm="12" md="3" style="padding-bottom: 1%">
            <b-button class="mt-3" @click="navigate('/texto/novo')" block variant="primary">
              <i class="fa fa-plus"></i>
              <span>Novo Texto</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col sm="4">
            <b-form-group label="Categoria:">
              <b-form-select v-model="filtros.categoria" :options="categorias" class="mb-3">
                <option selected :value="null">Selecione</option>
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col sm="4">
            <b-form-group label="Situação:">
              <b-form-select v-model="filtros.situacao" :options="situacao" class="mb-3">
                <option selected :value="null">Selecione</option>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="2">
            <b-button @click="limpafiltro" block variant="cinza">
              <i class="fa fa-eraser"></i>
              <span>Limpar filtros</span>
            </b-button>
          </b-col>
          <b-col md="2">
            <b-button @click="pesquisar" block variant="primary">
              <i class="fa fa-search"></i>
              <span>Pesquisar</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card-body>
      <b-row>
        <b-col sm="12">
          <b-container fluid>
            <span>
              <b-form-select style="width: 100px; float: right" class="mb-3" v-model="totalPorPagina" :options="totalSelectOp"></b-form-select>
              <table class="table table-responsive-sm table-bordered table-striped table-sm">
                <thead>
                  <tr>
                    <th scope="col">Categoria</th>
                    <th scope="col">Descrição</th>
                    <th width="5%" scope="col">Situação</th>
                    <th scope="col">Ações</th>
                  </tr>
                </thead>
                <tbody v-if="textos.data !== undefined">
                  <tr v-for="texto in textos.data" :key="texto.id">
                    <td>{{ categorias[texto.categoria] }}</td>
                    <td>{{ texto.descricao }}</td>
                    <td style="text-align: center;">
                      <b-badge variant="info" v-if="texto.ativo"> Ativo </b-badge>
                      <b-badge variant="warning" v-else> Inativo </b-badge>
                    </td>
                    <td style="width: 15%">
                      <a class="btn btn-sm btn-secondary action" title="Visualizar Texto" @click="visualizar(texto.id)">
                        <i class="fa fa-eye"></i>
                      </a>
                      <a class="btn btn-sm btn-secondary action" title="Editar Texto" @click="editar(texto.id)">
                        <i class="fa fa-pencil-square-o"></i>
                      </a>
                      <a class="btn btn-sm btn-secondary action" :title="texto.ativo ? 'Inativar Texto' : 'Ativar Texto'" @click="alterarSituacao(texto.id)">
                        <i :class="'fa fa-toggle-' + (texto.ativo ? 'off' : 'on')"></i>
                      </a>
                      <a class="btn btn-sm btn-secondary action" title="Excluir Texto" @click="excluir(texto.id)">
                        <i class="fa fa-times"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr style="text-align: center;">
                    <td colspan="4">Nenhum registro de texto de apresentação...</td>
                  </tr>
                </tbody>
              </table>
              <pagination
                v-show="textos.data !== undefined"
                :totalPorPagina="totalPorPagina"
                :resource="resource"
                :filtros="filtros"
              ></pagination>
            </span>
          </b-container>
        </b-col>
      </b-row>
    </b-card>
  </span>
</template>

<script>
import Vue from 'vue'
import Pagination from '@/components/shared/Pagination'
import miniToastr from 'mini-toastr'
import {eventType} from '@/components/shared/eventType'
import SessionStorage from '@/services/session-storage'

miniToastr.init()

export default {
  components: {
    Pagination
  },
  created () {
    if (SessionStorage.get('tipoPerfil').replace(/['"]+/g, '') === 'A') {
      this.$store.dispatch('getUsuario', SessionStorage.get('usuario'))
    } else {
      this.$router.push('/')
    }
  },
  data () {
    return {
      totalPorPagina: 20,
      totalSelectOp: [
        {text: '20', value: 20},
        {text: '30', value: 30},
        {text: '50', value: 50},
        {text: '100', value: 100}
      ],
      categorias: {
        BN: 'Beneficiária',
        VL: 'Voluntária',
        SM: 'Saiba Mais'
      },
      situacao: [
        {value: true, text: 'Ativo'},
        {value: false, text: 'Inativo'}
      ],
      resource: 'texto-app',
      filtros: {
        categoria: null,
        situacao: null
      }
    }
  },
  computed: {
    usuario () {
      return this.$store.state.usuario.usuarioEditar
    },
    textos () {
      if (this.$store.state.pagination.getList.data !== undefined) {
        if (this.$store.state.pagination.getList.data.length !== 0) {
          return this.$store.state.pagination.getList
        } else {
          return false
        }
      }
      return this.$store.state.pagination.getList
    }
  },
  watch: {},
  methods: {
    visualizar (id) {
      this.$router.push('/texto/visualizar/' + id)
    },
    editar (id) {
      this.$router.push('/texto/editar/' + id)
    },
    alterarSituacao (id) {
      this.$bvModal.msgBoxConfirm('Deseja realmente alterar a situação deste texto?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then((valor) => {
        if (valor) {
          Vue.http.put('api/texto/alterar-situacao/' + id).then((response) => {
            if (response.body.success) {
              this.alerta(true, response.body.msg)
              this.pesquisar()
            }
          }).catch((erro) => {
            if (!erro.body.success) {
              this.alerta(false, erro.body.msg)
            }
          })
        }
      })
    },
    excluir (id) {
      this.$bvModal.msgBoxConfirm('Deseja realmente excluir esse texto?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then((valor) => {
        if (valor) {
          Vue.http.delete('api/texto-app/' + id).then((response) => {
            if (response.body.success) {
              this.alerta(true, response.body.msg)
              this.pesquisar()
            }
          }).catch((erro) => {
            if (!erro.body.success) {
              this.alerta(false, erro.body.msg)
            }
          })
        }
      })
    },
    navigate (route) {
      this.$router.push(route)
    },
    limparFiltros () {
      this.filtros.categoria = null
      this.filtros.situacao = null
      this.totalPorPagina = 20
    },
    pesquisar () {
      this.$store.dispatch('getRegistrosSearch', {
        resource: this.resource,
        limit: this.totalPorPagina,
        filtros: this.filtros
      })
      this.setarFiltros(this.filtros)
    },
    limpafiltro () {
      this.filtros = {
        categoria: null,
        situacao: null
      }
      this.pesquisar()
    },
    setarFiltros (filtros) {
      eventType.$emit('app', filtros)
    },
    alerta (tipo, msg) {
      miniToastr.setIcon(tipo ? 'success' : 'error', 'i', {class: tipo ? 'fa fa-check' : 'fa fa-warning'})
      if (tipo) {
        miniToastr.success(msg, 'Sucesso!', 7000)
      } else {
        miniToastr.error(msg, 'Alerta!', 7000)
      }
    }
  }
}
</script>

<style scoped>
.action {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/site/interna/administrador/textoApresentacao/Textos.vue